import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getUrlVideoYoutube = async ({ token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SETTINGS.URL_YOUTUBE}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default getUrlVideoYoutube;